import React from 'react'
import { TableHead, TableRow, TableCell } from '@material-ui/core'

export const BigCalendarHeadBase = ({ classes, theme, sources }) => (
  <TableHead>
    <TableRow className={classes.tableRow}>

      <TableCell
        numeric
        padding='none'
        className={classes.tableCell}
      >
        Дата
      </TableCell>

      <TableCell
        numeric
        padding='none'
        className={classes.tableCell}
      >
        Перевізник
      </TableCell>

      <TableCell
        numeric
        padding='none'
        className={classes.tableCell}
      >
        Відомість
      </TableCell>

      {sources.map(({ label, id }) => (
        <TableCell
          numeric
          key={id}
          padding='none'
          className={classes.tableCell}
        >
          {label}
        </TableCell>
      ))}

      <TableCell
        numeric
        padding='dense'
        style={{
          paddingLeft: theme.spacing.unit,
          paddingRight: theme.spacing.unit,
        }}
      >
        Всього
      </TableCell>
      
    </TableRow>
  </TableHead>
)



// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/BigCalendarHead/BigCalendarHead.js